export default __webpack_public_path__ + "static/media/5g.12d5225a.svg";